<div class="flex-container flex-align-item-center" *ngIf="feedstock">
  <!--material search button-->
  <i id="feedstock-dropdowns-search_button"
    class="material-icons search-margin"
    (click)="onSearchClick()"
  >search</i>
  <!--material category dropdown-->
  <div class="dropdown-container flex-container flex-1 tour-cat-dropdowns">
    <div class="dropdown-item flex-box">
      <div (mouseenter)="showCatClear = true" (mouseleave)="showCatClear = false"
           class="form-field-container">
        <p
          *ngIf="showCatClear && selectedCategory"
          class="form-field-clear right"
          (click)="onClear('category')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
        <mat-form-field>
          <mat-label>{{'PROJECT.FEEDSTOCK.TYPE.CAT' | anessaTranslation: trigger}}</mat-label>
          <mat-select
            id="feedstock-dropdowns-category_select"
            [(ngModel)]="selectedCategory"
            placeholder="{{'PROJECT.FEEDSTOCK.TYPE.CAT' | anessaTranslation: trigger}}"
            disableOptionCentering
            (ngModelChange)="onCategoryChange($event)"
            [title]="feedstock.catTranslationId | anessaTranslation: trigger">
            <mat-option
              *ngFor="let category of materialCategories"
              [value]="category"
              title="{{ category.translationId | anessaTranslation: trigger}}"
            >{{ category.translationId | anessaTranslation: trigger }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!--material type dropdown-->
    <div class="dropdown-item flex-box">
      <div (mouseenter)="showTypeClear = true" (mouseleave)="showTypeClear = false"
           class="form-field-container">
        <p
          *ngIf="showTypeClear && selectedType"
          class="form-field-clear right"
          (click)="onClear('type')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
        <mat-form-field>
          <mat-label>{{'PROJECT.FEEDSTOCK.TYPE.TYPE' | anessaTranslation: trigger}}</mat-label>
          <mat-select
            id="feedstock-dropdowns-type_select"
            [(ngModel)]="selectedType"
            placeholder="{{'PROJECT.FEEDSTOCK.TYPE.TYPE' | anessaTranslation: trigger}}"
            disableOptionCentering
            (ngModelChange)="onTypeChange($event)"
            [title]="feedstock.typeTranslationId | anessaTranslation: trigger">
            <mat-option
              *ngFor="let type of materialTypes"
              [value]="type"
              title="{{ type.translationId  | anessaTranslation: trigger}}"
            >{{ type.translationId | anessaTranslation: trigger }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!--material source dropdown-->
    <div class="dropdown-item flex-box">
      <div (mouseenter)="showSourceClear = true" (mouseleave)="showSourceClear = false"
           class="form-field-container">
        <p
          *ngIf="showSourceClear && selectedSource"
          class="form-field-clear right"
          (click)="onClear('source')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
        <mat-form-field>
          <mat-label>{{'PROJECT.FEEDSTOCK.TYPE.SRC' | anessaTranslation: trigger}}</mat-label>
          <mat-select
            id="feedstock-dropdowns-source_select"
            [(ngModel)]="selectedSource"
            placeholder="{{'PROJECT.FEEDSTOCK.TYPE.SRC' | anessaTranslation: trigger}}"
            disableOptionCentering
            (ngModelChange)="onSourceChange($event)"
            [title]="feedstock.sourceTranslationId | anessaTranslation: trigger">
            <mat-option
              *ngFor="let source of materialSources"
              [value]="source"
              title="{{ source.translationId | anessaTranslation: trigger}}"
            >{{ source.translationId | anessaTranslation: trigger }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
